import { Avatar, Box, FlexBox, Icon, Text } from '@dixa/lib-shared-habla';

export const ContactItemContent = ({
  id,
  name,
  email,
  avatarUrl,
}: {
  id: string;
  name: string;
  email: string;
  avatarUrl?: string;
}): JSX.Element => {
  const isSuggestion = id === 'suggestion';
  return (
    <FlexBox gap="200" alignItems="center">
      {(isSuggestion && (
        <FlexBox padding="100">
          <Icon name="plus" size={24} />
        </FlexBox>
      )) || <Avatar user={{ display_name: name, avatar_url: avatarUrl }} />}
      <Box>
        {!isSuggestion &&
          ((name && <Text.Paragraph subdued>{name}</Text.Paragraph>) || (
            <Text.Paragraph>No name</Text.Paragraph>
          ))}
        <Text.Paragraph>{email}</Text.Paragraph>
      </Box>
    </FlexBox>
  );
};
